<template>
    <div class="px-[30px]">
        <full-training-view 
            v-if="showFullTrainingFlag" 
            @updateTrainings="updateTrainings" 
            @close="showFullTrainingFlag = false; fullDayViewFlag = true" 
            :training="trainingToView"
            @openFullWindow="fullWindowFlag = true"
            @closeFullWindow="fullWindowFlag = false"
            @deleteTraining="deleteEvent($event)" 
        />
        <new-training-form 
            v-if="newTrainingFormFlag" 
            @updateTrainings="updateTrainings" 
            @close="newTrainingFormFlag = false" 
            :date="currentNewTrainingDate"
        />
        <!-- <full-day-view 
            v-if="fullDayViewFlag" 
            @setTrainingToView="training => { trainingToView = training;  showFullTrainingFlag = true; fullDayViewFlag = false}" 
            @addTraining="$event => {newTrainingFormFlag = true; currentNewTrainingDate = $event}" 
            @deleteTraining="deleteEvent($event)" 
            @close="fullDayViewFlag = false" :day="fullDayViewDay"
        /> -->
        <!-- <div v-if="!fullWindowFlag" class="mt-[-22px] z-[100] absolute left-[50%] translate-x-[-50%] ml-[130px] top-[70px]">
            <div class="flex justify-center items-center select-none">
                <div>
                    <img @click="prevMonth" src="@/assets/icons/left_arrow.svg" class="cursor-pointer h-[14px]">
                </div>
                <div class="mx-2 w-[150px] text-center font-semibold text-[14px] text-[#FFF] relative top-[2px]">
                    {{ currentMonthParsed.toUpperCase() }} {{ currentYear }}
                </div>
                <div>
                    <img @click="nextMonth" src="@/assets/icons/right_arrow.svg" class="cursor-pointer h-[14px]">
                </div>
            </div>
        </div> -->
        
        <div 
            v-if="!fullWindowFlag"
            class="h-full overflow-x-auto"
            :class="{
                'w-full' : screenWidth > 1410,
                'w-[80vw]' : screenWidth <= 1410 && screenWidth > 1300,
                'w-[90vw]' : screenWidth <= 1300,
            }"    
        >
        <!-- class="w-[1190px] mx-auto  flex justify-center" -->
            <div >
                <!-- <CalenarComponent 
                    :days = "calendarParsedDays"
                    :unparsedDays = "calendarUnparsedDays"
                    @viewFull="viewFull($event)"
                    @addTraining="addTraining($event)"
                    class="w-[1190px] overflow-x-auto"
                /> -->
            </div>
        </div>
        <div v-if="!fullWindowFlag" class="ml-[75px] mb-[10px] flex items-center gap-3">
            <span class="text-[#fff] text-sm">Група:</span>
            <select v-model="selectedGroupId" class="bg-[#474849] bg-opacity-20 text-[#fff] border border-[#8C8C8C] rounded-[4px] px-3 py-1 outline-none">
                <option value="all" class="text-[#000]">Всі</option>
                <option v-for="group in groups" :key="group.group_id" :value="group.group_id" class="text-[#000]">{{ group.name }}</option>
            </select>
        </div>
        <button v-if="!fullWindowFlag && currentAdminRole != 'supervisor'" @click="newTrainingFormFlag = true" class="bg-[#BD9135] w-[150px] text-[#252526] text-center ml-[75px] mb-[10px] rounded-md py-1 hover:bg-opacity-90">Нова подія</button>
        <div v-if="calendarLoading" class="ml-[75px] mb-[10px] text-[#BD9135] text-sm">Завантаження календаря...</div>
        <datacalendar
            v-if="!fullWindowFlag"
            class="mb-[20px]"
            :allTrainings="filteredTrainings"
            @datesSet="onCalendarDatesSet"
            @setTrainingToView="training => { trainingToView = training;  showFullTrainingFlag = true; fullDayViewFlag = false}"
        />
    </div>
</template>

<script>
    import {computed, ref, onBeforeMount } from 'vue'
    import { 
        getAllTrainings, 
        getAllTrainerMeetUps, 
        deleteTrainingById, 
        deleteTrainerMeetUpById,
        getAllGroups,
        getAllAdminCalendarEvents,
        deleteAdminCalendarEventById
    } from '@/services/apiRequests'
    import CalenarComponent from './components/CalenarComponent.vue'
    import NewTrainingForm from './components/NewTrainingForm.vue'
    import FullDayView from './components/FullDayView.vue'
    import FullTrainingView from './components/FullTrainingView.vue'
    import datacalendar from './components/calendar/datacalendar.vue'

    export default {
        name: 'calendar',

        setup() {
            const currentDate = new Date()
            const currentYear = ref(currentDate.getFullYear())
            const currentMonth = ref(currentDate.getMonth())
            const currentMonthParsed = ref(currentDate.toLocaleString('uk-UA', { month: 'long' }))
            const calendarParsedDays = ref([])
            const calendarUnparsedDays = ref([])
            const newTrainingFormFlag = ref(false)
            const currentNewTrainingDate = ref(null)
            const allTrainings = ref([])
            const groups = ref([])
            const selectedGroupId = ref('all')
            const trainingToView = ref({})
            const showFullTrainingFlag = ref(false)

            const fullDayViewFlag = ref(false)
            const fullDayViewDay = ref(null)

            const fullWindowFlag = ref(false)
            const calendarKey = ref(0)
            const calendarLoading = ref(false)
            const currentRange = ref(null)
            const currentAdminRole = ref(localStorage.getItem('userType'))
            const isAdminCalendarRole = computed(() => ['admin', 'supervisor', 'top_manager'].includes(currentAdminRole.value))

            const toIsoDateTime = (value) => {
                if (!value) return null
                const date = value instanceof Date ? value : new Date(value)
                if (Number.isNaN(date.getTime())) return null
                return date.toISOString()
            }

            const viewFull = (day) => {
                fullDayViewFlag.value = true
                fullDayViewDay.value = day
            }

            const getWeekDayId = (dayName) => {
                switch (dayName) {
                    case 'пн':
                        return 1
                    case 'вт':
                        return 2
                    case 'ср':
                        return 3
                    case 'чт':
                        return 4
                    case 'пт':
                        return 5
                    case 'сб':
                        return 6
                    case 'нд':
                        return 7
                }
            }

            const getDays = (allTrainings) => {
                const lastDayInMonth = new Date(currentYear.value, currentMonth.value + 1, 0).getDate()
                
                const days = []

                for (let i = 1; i <= lastDayInMonth; i++) {
                    const currentDayDate = new Date(currentYear.value, currentMonth.value, i)
                    const dayName = currentDayDate.toLocaleString('uk-UA', { weekday: 'short' })
                    days.push({
                        dayName: dayName,
                        weekDayId: getWeekDayId(dayName),
                        dayNumber: i,
                        dateObj: currentDayDate,
                        trainings: allTrainings?.filter(training => new Date(training.date).toISOString().split('T')[0] === currentDayDate.toISOString().split('T')[0])
                    })
                }

                return days
            }

            const parseWeeksToCalendar = (allTrainings) => {
                const calendarDaysFull = new Array(42).fill(null)
                const currentMonthDays = getDays(allTrainings)
                let startMonthDay = 30 - (currentMonthDays[0].weekDayId - 2) 
                for (let i = 1; i <= 6; i++) {
                    for (let j = 1; j <= 7; j++) {
                        const currentDay = currentMonthDays[0]
                        if (currentDay?.weekDayId == j) {
                            calendarDaysFull[(i - 1) * 7 + j - 1] = currentDay
                            if (currentDay.dayNumber == new Date().getDate() && currentDay.dateObj.getMonth() == new Date().getMonth() && currentDay.dateObj.getFullYear() == new Date().getFullYear()) {
                                calendarDaysFull[(i - 1) * 7 + j - 1].is_current = true
                            } else {
                                calendarDaysFull[(i - 1) * 7 + j - 1].is_current = false
                            }
                            currentMonthDays.shift()
                            startMonthDay = 1
                        } else {
                            calendarDaysFull[(i - 1) * 7 + j - 1] = {
                                type: 'empty',
                                month_day: startMonthDay
                            }
                            startMonthDay++
                        }
                    }
                }

                return calendarDaysFull
            }

            const nextMonth = () => {
                if (currentMonth.value == 11) {
                    currentMonth.value = 0
                    currentYear.value++
                } else {
                    currentMonth.value++
                }
                currentMonthParsed.value = new Date(currentYear.value, currentMonth.value, 1).toLocaleString('uk-UA', { month: 'long' })
                calendarParsedDays.value = parseWeeksToCalendar(allTrainings.value)
                calendarUnparsedDays.value = getDays(allTrainings.value)
            }

            const prevMonth = () => {
                if (currentMonth.value == 0) {
                    currentMonth.value = 11
                    currentYear.value--
                } else {
                    currentMonth.value--
                }
                currentMonthParsed.value = new Date(currentYear.value, currentMonth.value, 1).toLocaleString('uk-UA', { month: 'long' })
                calendarParsedDays.value = parseWeeksToCalendar(allTrainings.value)
                calendarUnparsedDays.value = getDays(allTrainings.value)
            }

            const addTraining = (date) => {
                newTrainingFormFlag.value = true
                currentNewTrainingDate.value = date.dateObj
            }

            const newCalendarFlag = ref(true)

            const filteredTrainings = computed(() => {
                if (selectedGroupId.value === 'all') return allTrainings.value
                return allTrainings.value.filter(training => training.group_id == selectedGroupId.value)
            })

            const updateTrainings = async (range = currentRange.value) => {
                calendarLoading.value = true
                try {
                    const dateFrom = toIsoDateTime(range?.start)
                    const dateTo = toIsoDateTime(range?.end)

                    const requests = [
                        getAllTrainings(dateFrom, dateTo, true),
                        getAllTrainerMeetUps(dateFrom, dateTo),
                    ]
                    if (isAdminCalendarRole.value) {
                        requests.push(getAllAdminCalendarEvents(dateFrom, dateTo, true))
                    }

                    const results = await Promise.all(requests)
                    const trainingsRes = results[0]
                    const all_meet_ups = results[1] || []
                    const adminEventsResponse = isAdminCalendarRole.value ? results[2] : []
                    const adminEvents = Array.isArray(adminEventsResponse) ? adminEventsResponse : adminEventsResponse?.data || []

                    const combinedTrainings = [
                        ...(trainingsRes?.data || []),
                        ...(all_meet_ups || []),
                        ...(isAdminCalendarRole.value ? adminEvents : [])
                    ]

                    allTrainings.value = combinedTrainings
                    calendarParsedDays.value = parseWeeksToCalendar(allTrainings.value)
                    calendarUnparsedDays.value = getDays(allTrainings.value)

                    fullDayViewDay.value?.trainings.forEach((training, id) => {
                        const currentTraining = combinedTrainings.find(t => (t.training_id ?? t.meet_up_id ?? t.event_id) === (training.training_id ?? training.meet_up_id ?? training.event_id))
                        if (currentTraining) {
                            fullDayViewDay.value.trainings[id] = currentTraining
                        }
                    })

                    combinedTrainings.forEach((training) => {
                        if (
                            fullDayViewDay.value?.dateObj &&
                            new Date(training.date).toISOString().split('T')[0] === fullDayViewDay.value.dateObj.toISOString().split('T')[0] &&
                            !fullDayViewDay.value.trainings.find(t => (t.training_id ?? t.meet_up_id ?? t.event_id) === (training.training_id ?? training.meet_up_id ?? training.event_id))
                        ) {
                            fullDayViewDay.value.trainings.push(training)
                        }
                    })
                } finally {
                    calendarLoading.value = false
                }
            }

            const onCalendarDatesSet = async ({ start, end }) => {
                const nextRange = { start, end }
                const sameRange =
                    currentRange.value &&
                    toIsoDateTime(currentRange.value.start) === toIsoDateTime(start) &&
                    toIsoDateTime(currentRange.value.end) === toIsoDateTime(end)

                currentRange.value = nextRange
                if (sameRange) {
                    return
                }
                await updateTrainings(nextRange)
            }

            const deleteEvent = async (payload) => {
                const normalizedPayload = typeof payload === 'object' ? payload : { id: payload }
                const id = normalizedPayload?.id ?? payload
                const type = normalizedPayload?.type ?? null

                // fullDayViewDay.value.trainings = fullDayViewDay.value.trainings.filter(t => (t.training_id && t.training_id !== id) || (t.meet_up_id && t.meet_up_id !== id)); 
                if (type === 'trainer_meetup') {
                    await deleteTrainerMeetUpById(id)
                } else if (type === 'selection') {
                    await deleteAdminCalendarEventById(id)
                } else {
                    await deleteTrainingById(id)
                }
                allTrainings.value = allTrainings.value.filter(t => (t.training_id && t.training_id !== id) || (t.meet_up_id && t.meet_up_id !== id) || (t.event_id && t.event_id !== id));
                await updateTrainings()
                showFullTrainingFlag.value = false
                // calendarKey.value++
            } 

            onBeforeMount(async () => {
                const groupsRes = await getAllGroups()
                groups.value = groupsRes.data || []
                // Events load via FullCalendar datesSet for the visible range
            })

            return {
                calendarParsedDays,
                currentMonthParsed,
                currentYear,
                nextMonth,
                prevMonth,
                calendarUnparsedDays,
                addTraining,
                newTrainingFormFlag,
                currentNewTrainingDate,
                updateTrainings,
                onCalendarDatesSet,
                calendarLoading,
                fullDayViewFlag,
                fullDayViewDay,
                viewFull,
                trainingToView,
                showFullTrainingFlag,
                deleteEvent,
                fullWindowFlag,
                allTrainings,
                filteredTrainings,
                newCalendarFlag,
                calendarKey,
                currentAdminRole,
                groups,
                selectedGroupId,
                isAdminCalendarRole
            }
        },

        components: {
            CalenarComponent,
            NewTrainingForm,
            FullDayView,
            FullTrainingView,
            datacalendar
        }
    }
</script>
